import { createAction } from '@reduxjs/toolkit'
import dayjs from 'dayjs'

import {
  IBetHistoryFilters,
  IBetHistoryItem,
  IConvertedBetHistory,
  IConvertedSession,
  ICreateSessionPayload,
  ISubbetActionReturn,
} from 'shared/models/Softion'
import { makeCommunicationActionCreator } from 'shared/utils/communication/actions/makeCommunicationActionCreator'

import { addNotify } from 'components/Notify/addNotify'

const CHANGE_ACTIVE_BET = '@softion/CHANGE_ACTIVE_BET'

export const changeActiveBet = createAction<IBetHistoryItem>(CHANGE_ACTIVE_BET)

export const getBetHistory = makeCommunicationActionCreator({
  loading: '@softion/GET_BET_HISTORY_LOADING',
  success: '@softion/GET_BET_HISTORY_SUCCESS',
  error: '@softion/GET_BET_HISTORY_ERROR',
  reset: '@softion/GET_BET_HISTORY_RESET',
})<IBetHistoryFilters, IConvertedBetHistory>(async ({
  deps: {
    extra: { api },
  },
  payload,
}) => {
  const filters = {
    ...payload,
    date_from: payload.date_from ? dayjs(payload.date_from).startOf('day').format('YYYY-MM-DDTHH:mmZ') : undefined,
    date_to: payload.date_to
      ? dayjs(payload.date_to).add(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mmZ')
      : undefined,
    final_status_in: payload.final_status_in ? payload.final_status_in : undefined,
  }

  const response = await api.softion.getBetHistory(filters)
  return response.data
})

export const cancelTicket = makeCommunicationActionCreator({
  loading: '@softion/CANCEL_TICKET_LOADING',
  success: '@softion/CANCEL_TICKET_SUCCESS',
  error: '@softion/CANCEL_TICKET_ERROR',
  reset: '@softion/CANCEL_TICKET_RESET',
})<number, any>(async ({
  deps: {
    extra: { api },
  },
  payload,
}) => {
  const response = await api.softion.cancelTicket(payload)

  if (response.success) {
    addNotify('Ticket canceled', 'success')
  }
})

export const getSubBet = makeCommunicationActionCreator({
  loading: '@softion/GET_SUBBET_LOADING',
  success: '@softion/GET_SUBBET_SUCCESS',
  error: '@softion/GET_SUBBET_ERROR',
  reset: '@softion/GET_SUBBET_RESET',
})<number, void>(async ({
  deps: {
    extra: { api },
  },
  payload,
}) => {
  // const response = await api.softion.getSubBet(payload)
  // return {
  //   id: payload,
  //   info: response.data,
  // }
})

export const createSession = makeCommunicationActionCreator({
  loading: '@softion/CREATE_SESSION_LOADING',
  success: '@softion/CREATE_SESSION_SUCCESS',
  error: '@softion/CREATE_SESSION_ERROR',
  reset: '@softion/CREATE_SESSION_RESET',
})<ICreateSessionPayload, IConvertedSession>(async ({
  deps: {
    extra: { api },
  },
  payload,
}) => {
  const response = await api.softion.createSession(payload)
  return response.data
})

export const clearSession = makeCommunicationActionCreator({
  loading: '@softion/CLEAR_SESSION_LOADING',
  success: '@softion/CLEAR_SESSION_SUCCESS',
  error: '@softion/CLEAR_SESSION_ERROR',
  reset: '@softion/CLEAR_SESSION_RESET',
})(async ({
  deps: {
    getState,
    extra: { api },
  },
}) => {
  const token = getState().softion.data.sessionUrl?.token
  if (token) {
    await api.softion.clearSession({
      token,
    })
  }
})
